<template>
	<div class="pb-4 w-full flex">
		<!-- Borrowing the container from resources... -->
		<router-link :to="`/blogs/${blog.id}`" class="w-full flex flex-col trans cursor-pointer flex-grow relative card-shadow bg-white dark:bg-gray-800 rounded hover:scale-[101%] hover:border-gray-500 transition-all">

			<div class="flex flex-col justify-between w-full">
				<div class="p-8 flex flex-col flex-grow justify-center">
					<div class="font-bold text-grey-900 text-xl pb- dark:text-white/70">{{ blog.title }}</div>
					<div class="text-grey-500 text-xs uppercase pb-2 tracking-2xl">
						 {{ dayjs(blog.startDate).format("MMMM D, YYYY") }}
					</div>
					<div class="text-xs text-grey-900 line-clamp-5 max-h-24 dark:text-white/40">{{ blog.bodyMin }}</div>
				</div>
			</div>

			<div
				v-if="store.user?.member?.roles?.includes?.('admin')"
				class="px-1 text-xs border rounded font-thin absolute top-0 right-0 m-4 dark:text-white"
				:class="status == 'live' ? 'border-ncfic-green-200 text-ncfic-green bg-ncfic-green-50 dark:bg-ncfic-green-700' : 'border-grey-200 dark:bg-gray-700 text-grey-600 bg-grey-50'"
			>{{ status }}</div>
		</router-link>
	</div>
</template>

<script>
import dayjs from 'dayjs'

export default {
	props: ['blog'],
    inject: ['store'],
	computed: {
		status() {
			let status = this.blog.status.toLowerCase()
			return status == 'open' || status == 'Open' ? 'live' : status
		}
	},
    methods: {
        dayjs
    }
}
</script>
